'use strict';

import { BaseController } from '../../base/controller';

export class BreadcrumbController extends BaseController {
  constructor(controllerService) {
    'ngInject';
    super({ controllerService });
  }

  isStepFirst() {
    return this.currentStep === 0;
  }

  isStepLast() {
    return this.currentStep >= this.steps.length - 1;
  }

  isStepDone(index) {
    return index < this.currentStep;
  }

  isComplete() {
    return this.currentStep > this.steps.length - 1;
  }

  getStepClass(index) {
    if (index > this.currentStep) {
      return 'ui-breadcrumb-next';
    }
    else if (index < this.currentStep) {
      return 'ui-breadcrumb-prev';
    }
    // index === this.currentStep
    return 'ui-breadcrumb-current';
  }
}
